import { Component, OnInit, Output, EventEmitter, Injectable, Inject, ViewChild, Input, ElementRef } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http.service';

@Component({
    selector: 'autocomplete-customer',
    templateUrl: './autocomplete-customer.html'
})
export class AutoCompleteCustomerComponent implements OnInit {

    public dataSource: Array<any> = [];
    public fields: Object = { value: 'CustomerCode' };
    // set the placeholder to the AutoComplete input
    public watermark: string = 'e.g. Andrew Fuller';
    public keyword: string = "";
    constructor(private http: HttpService, @Inject('BASE_URL') public baseUrl: string) {

    }

    ngOnInit() {



    }
    onFiltering(e) {
        let keyword = e.text;
        if (keyword && keyword.length > 2) {
            this.http.get('api/Customer/SearchCustomerMasterByName/' + keyword, res => {
                this.dataSource = res.Result;

            }, null);
        }
      

    }
}
